<template>
  <div>
    <NavigationBar titel="Konfiguration" isPreview> </NavigationBar>
  </div>
</template>

<script>
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
export default {
  name: "stats-config",
  components: { NavigationBar },
};
</script>
